// import React from 'react';
// import { CButton, CHeader, CHeaderNav } from '@coreui/react';
// import { cilBell, cilUser, cilEnvelopeOpen } from '@coreui/icons';
// import { CIcon } from '@coreui/icons-react';
// import { CAvatar } from '@coreui/react';
// import { useNavigate } from 'react-router-dom'; // 👈 import useNavigate

// const Topbar = () => {
//   const navigate = useNavigate(); // 👈 initialize navigate

//   const handleNotificationClick = () => {
//     navigate('/notifications'); // 👈 redirect to /notifications
//   };

//   return (
//     <CHeader className="bg-light d-flex justify-content-between px-3 py-2" style={{ zIndex: 999 }}>
//       <CHeaderNav>
//         <CButton color="link" className="d-md-none" onClick={handleNotificationClick}>
//           <CIcon icon={cilBell} />
//         </CButton>
//       </CHeaderNav>

//       <CHeaderNav>
//         <CHeaderNav className="mx-3" onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
//           <CIcon icon={cilBell} size="lg" />
//         </CHeaderNav>
//         <CHeaderNav className="mx-3">
//           <CIcon icon={cilEnvelopeOpen} size="lg" />
//         </CHeaderNav>
//         <CHeaderNav className="mx-3">
//           <CAvatar src="https://via.placeholder.com/40" size="sm" />
//         </CHeaderNav>
//       </CHeaderNav>
//     </CHeader>
//   );
// };

// export default Topbar;



import React, { useState } from 'react';
import { CButton, CHeader, CHeaderNav, CDropdown, CDropdownToggle, CDropdownMenu, CDropdownItem } from '@coreui/react';
import { cilBell, cilUser, cilEnvelopeOpen } from '@coreui/icons';
import { CIcon } from '@coreui/icons-react';
import { CAvatar } from '@coreui/react';
import { useNavigate } from 'react-router-dom'; 
import { useNotification } from '../../context/appContext';

const Topbar = () => {
  const [notificationCount, setNotificationCount] = useState(3);
  const navigate = useNavigate(); 
  const { notifications } = useNotification();
  // const navigate = useNavigate();

  
  const unreadCount = notifications.filter((n) => !n.is_read).length;
  // console.log(notifications,"Notification")

  // Handle notification click
  const handleNotificationClick = () => {
    navigate('/notifications'); 
  };

  // Handle logout
  const handleLogout = () => {
    localStorage.removeItem('token'); 
    navigate('/'); 
  };

  return (
    <CHeader className=" d-flex justify-content-between px-3 py-4 topbar-gradient"    style={{
      zIndex: 999,
      position: 'sticky',  
      top: 0,  
      width: '100%', 
    }}>
      <CHeaderNav>
        {/* <CButton color="link" className="d-md-none" onClick={handleNotificationClick}>
          <CIcon icon={cilBell} />
        </CButton> */}
      </CHeaderNav>

      <CHeaderNav>
        <CHeaderNav className="mx-3" onClick={handleNotificationClick} style={{ cursor: 'pointer' }}>
          <div className="position-relative">
            <CIcon icon={cilBell} size="lg" />
            {unreadCount > 0 ? (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill bell-badge"
                style={{ fontSize: '0.8rem' }}
              >
                {unreadCount}
              </span>
            ):  <span
            className="position-absolute top-0 start-100 translate-middle badge rounded-pill bell-badge"
            style={{ fontSize: '0.8rem' }}
          >
          {"0"}
          </span>}
          </div>
        </CHeaderNav>
        <CHeaderNav className="mx-3">
          <CIcon icon={cilEnvelopeOpen} size="lg" />
        </CHeaderNav>

        {/* Profile Avatar with Dropdown */}
        <CHeaderNav className="mx-3">
          <CDropdown>
            <CDropdownToggle color="link" className="p-0">
              <CAvatar src="https://png.pngtree.com/png-vector/20190710/ourmid/pngtree-user-vector-avatar-png-image_1541962.jpg" size="sm" />
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem className='cursor-pointer' onClick={() => navigate('/profile')}>Profile</CDropdownItem>
              <CDropdownItem className='cursor-pointer'  onClick={handleLogout}>Logout</CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </CHeaderNav>
      </CHeaderNav>
    </CHeader>
  );
};

export default Topbar;

